module.exports = __webpack_public_path__ + "img/retail-gray.8cc62880.png";